import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() { super('Boot'); }

  preload() {
    // minimal loading bar background
  }

  create() {
    this.scene.start('Preload');
  }
}
